module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst {\nstatus = 'preStatus',\nstatusUpdatedAt,\n} = model.projectMeta || {}\n%><div>\n<section class=\"top\">\n<p><%- storage.__(`hint.customers.order.byStatusCode.${status}`, { ts: utils.moment(statusUpdatedAt).format('DD.MM.YYYY [um] HH:mm') }) %></p>\n</section>\n<section class=\"bottom\">\n<p><%- storage.__('hint.customers.order.mandatoryFieldsAsterisk') %></p>\n</section>\n</div>"
  , __filename = "components/templates/customers/projects/orderHints.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const {
status = 'preStatus',
statusUpdatedAt,
} = model.projectMeta || {}

    ; __line = 6
    ; __append("<div>\n<section class=\"top\">\n<p>")
    ; __line = 8
    ; __append( storage.__(`hint.customers.order.byStatusCode.${status}`, { ts: utils.moment(statusUpdatedAt).format('DD.MM.YYYY [um] HH:mm') }) )
    ; __append("</p>\n</section>\n<section class=\"bottom\">\n<p>")
    ; __line = 11
    ; __append( storage.__('hint.customers.order.mandatoryFieldsAsterisk') )
    ; __append("</p>\n</section>\n</div>")
    ; __line = 13
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/customers/projects/orderHints.ejs

}